import { render, staticRenderFns } from "./InspectionExpansionPanel.vue?vue&type=template&id=0dfe7880&scoped=true&"
import script from "./InspectionExpansionPanel.vue?vue&type=script&lang=js&"
export * from "./InspectionExpansionPanel.vue?vue&type=script&lang=js&"
import style0 from "./InspectionExpansionPanel.vue?vue&type=style&index=0&id=0dfe7880&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfe7880",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListTile } from 'vuetify/lib/components/VList';
import { VListTileAction } from 'vuetify/lib/components/VList';
import { VListTileContent } from 'vuetify/lib/components/VList';
installComponents(component, {VChip,VExpansionPanel,VExpansionPanelContent,VFlex,VIcon,VLayout,VList,VListTile,VListTileAction,VListTileContent})
